"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _oxygenInput = _interopRequireDefault(require("@8x8/oxygen-input"));
var _StyledDateTimeRangeSelectorPredefinedList = require("../styled/StyledDateTimeRangeSelectorPredefinedList");
var _constants = _interopRequireDefault(require("../utils/constants"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getInputValueProperty = function getInputValueProperty(id) {
  return "inputValue[".concat(id, "]");
};
var getHasErrorProperty = function getHasErrorProperty(id) {
  return "hasError[".concat(id, "]");
};
var DateTimeRangeSelectorPredefinedList = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateTimeRangeSelectorPredefinedList, _PureComponent);
  var _super = _createSuper(DateTimeRangeSelectorPredefinedList);
  function DateTimeRangeSelectorPredefinedList(props) {
    var _this;
    _classCallCheck(this, DateTimeRangeSelectorPredefinedList);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onChangePredefinedRangeInputValue", function (_ref) {
      var _this$setState;
      var _ref$target = _ref.target,
        value = _ref$target.value,
        name = _ref$target.name;
      var _this$props = _this.props,
        onRangeSelect = _this$props.onRangeSelect,
        id = _this$props.selectedRange.id;
      var isNaN = Number.isNaN;
      var valueNumber = parseInt(value, 10);
      var hasError = !value || !valueNumber || isNaN(valueNumber) || valueNumber < 1 || valueNumber > 99;
      _this.setState((_this$setState = {}, _defineProperty(_this$setState, getInputValueProperty(name), "".concat(value)), _defineProperty(_this$setState, getHasErrorProperty(name), hasError), _this$setState));
      if (!hasError) {
        onRangeSelect({
          id: id,
          value: valueNumber
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "updateInputValue", function (value, id) {
      var _this$setState2;
      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, getInputValueProperty(id), "".concat(value)), _defineProperty(_this$setState2, getHasErrorProperty(id), false), _this$setState2));
    });
    _defineProperty(_assertThisInitialized(_this), "selectRange", function (_ref2) {
      var id = _ref2.id,
        hasArgument = _ref2.hasArgument;
      var _this$props2 = _this.props,
        selectedId = _this$props2.selectedRange.id,
        onRangeSelect = _this$props2.onRangeSelect;
      var _this$state = _this.state,
        currentInputValue = _this$state[getInputValueProperty(id)],
        hasError = _this$state[getHasErrorProperty(id)];
      if (id === selectedId) {
        return;
      }
      var rangeValue;
      if (hasArgument) {
        if (currentInputValue && !hasError) {
          rangeValue = parseInt(currentInputValue, 10);
        } else {
          rangeValue = '1';
        }
      }
      onRangeSelect({
        id: id,
        value: rangeValue
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderListItem", function (range, isSelected) {
      var displayName = range.displayName,
        hasArgument = range.hasArgument,
        id = range.id;
      var _this$props3 = _this.props,
        _this$props3$theme = _this$props3.theme,
        listInputHorizontalSpacing = _this$props3$theme.listInputHorizontalSpacing,
        listInputMinWidth = _this$props3$theme.listInputMinWidth,
        listInputWidth = _this$props3$theme.listInputWidth,
        listInputVerticalSpacing = _this$props3$theme.listInputVerticalSpacing,
        testId = _this$props3.testId;
      var listInputTheme = {
        horizontalSpacing: listInputHorizontalSpacing,
        width: listInputWidth,
        minWidth: listInputMinWidth,
        verticalSpacing: listInputVerticalSpacing
      };
      if (isSelected && hasArgument) {
        var _this$state2 = _this.state,
          currentInputValue = _this$state2[getInputValueProperty(id)],
          hasError = _this$state2[getHasErrorProperty(id)];
        var selectedDisplayName = range.selectedDisplayName;
        var _selectedDisplayName = _slicedToArray(selectedDisplayName, 2),
          firstLabel = _selectedDisplayName[0],
          secondLabel = _selectedDisplayName[1];
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, firstLabel, /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorPredefinedList.PredefinedListInputWrapper, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_INPUT_CONTAINER")), /*#__PURE__*/_react["default"].createElement(_oxygenInput["default"], {
          testId: "".concat(testId, "_INPUT"),
          value: currentInputValue,
          name: id,
          maxLength: 2,
          theme: listInputTheme,
          onChange: _this.onChangePredefinedRangeInputValue,
          hasError: hasError,
          size: "small"
        })), secondLabel);
      }
      return displayName;
    });
    var ranges = props.ranges,
      selectedRange = props.selectedRange;
    var initialInputValues = _this.getInitialState(ranges, selectedRange);
    _this.state = _objectSpread({}, initialInputValues);
    return _this;
  }
  _createClass(DateTimeRangeSelectorPredefinedList, [{
    key: "getInitialState",
    value: function getInitialState(ranges, selectedRange) {
      var initialState = {};
      ranges.forEach(function (range) {
        var hasArgument = range.hasArgument,
          id = range.id;
        if (hasArgument) {
          var _Object$assign;
          Object.assign(initialState, (_Object$assign = {}, _defineProperty(_Object$assign, getInputValueProperty(id), id === selectedRange.id && selectedRange.value ? "".concat(selectedRange.value) : ''), _defineProperty(_Object$assign, getHasErrorProperty(id), false), _Object$assign));
        }
      });
      return initialState;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$selectedR = this.props.selectedRange;
      _this$props$selectedR = _this$props$selectedR === void 0 ? {} : _this$props$selectedR;
      var id = _this$props$selectedR.id,
        value = _this$props$selectedR.value;
      var _prevProps$selectedRa = prevProps.selectedRange;
      _prevProps$selectedRa = _prevProps$selectedRa === void 0 ? {} : _prevProps$selectedRa;
      var previousValue = _prevProps$selectedRa.value;
      if (!value || previousValue === value) {
        return;
      }
      this.updateInputValue(value, id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        ranges = _this$props4.ranges,
        selectedRange = _this$props4.selectedRange,
        testId = _this$props4.testId,
        hideCustomRange = _this$props4.hideCustomRange,
        customPredefinedRangeLabel = _this$props4.customPredefinedRangeLabel;
      return /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorPredefinedList.PredefinedList, (0, _oxygenConfig.getTestAttributes)(testId), ranges.map(function (range) {
        var isSelected = "".concat(range.id) === "".concat(selectedRange.id);
        return /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorPredefinedList.PredefinedListItem, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ITEM")), {
          key: range.id,
          isSelected: isSelected,
          onClick: function onClick() {
            return _this2.selectRange(range);
          }
        }), _this2.renderListItem(range, isSelected));
      }), !hideCustomRange && /*#__PURE__*/_react["default"].createElement(_StyledDateTimeRangeSelectorPredefinedList.PredefinedListItem, _extends({}, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ITEM")), {
        key: "Custom",
        isSelected: selectedRange.id === _constants["default"],
        onClick: function onClick() {
          return _this2.selectRange({
            id: _constants["default"]
          });
        }
      }), customPredefinedRangeLabel));
    }
  }]);
  return DateTimeRangeSelectorPredefinedList;
}(_react.PureComponent);
DateTimeRangeSelectorPredefinedList.propTypes = {
  theme: _propTypes["default"].object.isRequired,
  ranges: _propTypes["default"].array.isRequired,
  selectedRange: _propTypes["default"].object.isRequired,
  customPredefinedRangeLabel: _propTypes["default"].string.isRequired,
  onRangeSelect: _propTypes["default"].func,
  testId: _propTypes["default"].string,
  hideCustomRange: _propTypes["default"].bool
};
DateTimeRangeSelectorPredefinedList.defaultProps = {
  onRangeSelect: _lodash["default"],
  testId: 'DATE_TIME_RANGE_SELECTOR_DROPDOWN_PREDEFINED_LIST',
  hideCustomRange: false
};
var _default = DateTimeRangeSelectorPredefinedList;
exports["default"] = _default;